import PropTypes from 'prop-types';
// @mui
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
// auth
import { useAuthContext } from 'src/auth/hooks';
// routes
import { paths } from 'src/routes/paths';
import { RouterLink } from 'src/routes/components';
// hooks
import { useResponsive } from 'src/hooks/use-responsive';
// theme
import { bgGradient } from 'src/theme/css';
// components
import Logo from 'src/components/logo';
import {useAxStore} from "../../store/axStore";

// ----------------------------------------------------------------------

const METHODS = [
  {
    id: 'jwt',
    label: 'Jwt',
    path: paths.auth.jwt.login,
    icon: '/assets/icons/auth/ic_jwt.svg',
  }
];

export default function AuthClassicLayout({ children, image, title }) {
  const { method } = useAuthContext();

  const theme = useTheme();

  const upMd = useResponsive('up', 'md');
  const axStore=useAxStore();
  const randomImageNumber=Math.floor(Math.random() * (8 - 1) + 1);

  const renderLogo = (
    <Logo
      sx={{
        zIndex: 9,
        position: 'absolute',
        m: { xs: 2, md: 5 },
      }}
    />
  );

  const renderContent = (
    <Stack
      sx={{
        width: 1,
        mx: 'auto',
        maxWidth: 480,
        px: { xs: 2, md: 8 },
        py: { xs: 15, md: 30 },
      }}
    >
      {children}
    </Stack>
  );

  const renderSection = (
    <Stack
      flexGrow={1}
      alignItems="center"
      justifyContent="center"
      spacing={10}
      sx={{
        ...bgGradient({
          direction: '135deg',
          startColor: alpha(theme.palette.primary.main, 1),
          endColor: alpha(theme.palette.primary.darker, 1),
        }),
      }}
    >
      <Box
        component="img"
        alt="auth"
        /* src={image || axStore.systemCurrentConfig.systemName==="piXme"?`/assets/images/login/${randomImageNumber}.jpg`:'/assets/illustrations/illustration_dashboard.png'} */
         src='https://pixme-preview.fra1.digitaloceanspaces.com/b275aac13d6aaa5a1c20231577217530.png'

        sx={{ maxWidth: 300 }}
      />

      <Typography variant="body" sx={{ fontSize:"1.5em",maxWidth: 480, textAlign: 'center',color:"#fff" }}>
        {title || axStore.systemCurrentConfig.systemName==="piXme"?`piXme ${axStore.systemCurrentConfig.systemVersion}`:`AdministriX ${axStore.systemCurrentConfig.systemVersion}`}
      </Typography>



    </Stack>
  );

  return (
    <Stack
      component="main"
      direction="row"
      sx={{
        minHeight: '100vh',
      }}
    >
      {renderLogo}

      {upMd && renderSection}

      {renderContent}
    </Stack>
  );
}

AuthClassicLayout.propTypes = {
  children: PropTypes.node,
  image: PropTypes.string,
  title: PropTypes.string,
};
